import { render, staticRenderFns } from "./StandardTemplateEditor.vue?vue&type=template&id=2236cf35&scoped=true&"
import script from "./StandardTemplateEditor.vue?vue&type=script&lang=js&"
export * from "./StandardTemplateEditor.vue?vue&type=script&lang=js&"
import style0 from "./StandardTemplateEditor.vue?vue&type=style&index=0&id=2236cf35&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2236cf35",
  null
  
)

export default component.exports